// Komponenten <eui-document-viewer-dialog>:

import Vue from 'vue';

import { euiLifecycleStatusesMixin } from 'v-mixins/euiLifecycleStatusesMixin';

import euiDialogClasses from 'v-components/classes/euiDialogClasses';
import euiDialog from 'v-components/euiDialog';
import euiKnapp from 'v-components/euiKnapp';
import euiModifieradSvg from 'v-components/euiModifieradSvg';

import objectToFormData from 'object-to-formdata';


// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
let uniktIdCounter = 0;


//###################################################################################################

export default {

	name: 'eui-document-viewer-dialog',

	template: `
		<eui-dialog
			:vp-dialog-id="dialogId"
			:vp-bredd-med-enhet="vpBreddMedEnhet"
			vp-visa-verktygsfalt-istallet-for-huvud-text
			vp-utan-padding-pa-kroppen
			:vp-visa-foten="vpVisaFoten"
			:vp-fot-text="vpFotText"
			:vp-visa-dialogen.sync="dialogConfig.visas"
			:vp-dialog-stack="vpDialogStack"
			:vp-dialog-config="dialogConfig"
			@knapp-tryckt-i-dialog="onKnappTrycktIDialog"
			@dialogen-inaktiverad="onDialogenInaktiverad"
			@dialogen-stangs="onDialogenStangs"
		>
			<template #verktygsfalt>

				<eui-knapp
					vp-css-modifier-class="-transparent"
					vp-tooltip="Ladda ner originalfilen"
					:vp-inaktiverad="VerktygsfaltetSkaVaraInaktiverat"
					@tryckt="onLaddaNer()"
					style="
						display: flex;
						align-items: center;
						height: 32px;
						padding: .4em;
						flex: none;
						border: 0;
						border-radius: 3px;
						margin-left: 1em;
					"
				>
					<eui-modifierad-svg
						vp-ikon="laddaNer"
					></eui-modifierad-svg>

					<span class="mellan" style="display: inline; line-height: 1;">&nbsp; Ladda ner&nbsp;</span>
				</eui-knapp>

				<eui-knapp
					vp-css-modifier-class="-transparent"
					vp-tooltip="Skriv ut dokumentet"
					:vp-inaktiverad="VerktygsfaltetSkaVaraInaktiverat"
					@tryckt="onSkrivUt()"
					style="
						display: flex;
						align-items: center;
						height: 32px;
						padding: .4em;
						flex: none;
						border: 0;
						border-radius: 3px;
						margin-left: 0;
					"
				>
					<eui-modifierad-svg
						vp-ikon="skrivUt"
					></eui-modifierad-svg>

					<span class="mellan" style="display: inline; line-height: 1;">&nbsp; Skriv ut&nbsp;</span>
				</eui-knapp>



				<div style="width: 1px; height: 65%; background-color:#ccc; margin: .5em;"></div>



				<eui-knapp
					vp-css-modifier-class="-transparent"
					vp-tooltip="Zooma ut"
					:vp-inaktiverad="ZoommaUtSkaVaraInaktiverad"
					@tryckt="onZoomaUt()"
					style="width: 32px; height: 32px; padding: .4em; flex: none; border: 0; border-radius: 3px; margin-left: 0;"
				>
					<eui-modifierad-svg
						vp-ikon="zoomaUt"
					></eui-modifierad-svg>
				</eui-knapp>

				<eui-knapp
					vp-css-modifier-class="-transparent"
					vp-tooltip="Zooma in"
					:vp-inaktiverad="ZoommaInSkaVaraInaktiverad"
					@tryckt="onZoomaIn()"
					style="width: 32px; height: 32px; padding: .4em; flex: none; border: 0; border-radius: 3px; margin-left: 0;"
				>
					<eui-modifierad-svg
						vp-ikon="zoomaIn"
					></eui-modifierad-svg>
				</eui-knapp>

				<span class="mellan" style="display: inline; line-height: 1; width: 3.4rem; text-align: center; user-select: none;">{{ documentViewerZoomLevel }}<span class="thinspace">&nbsp;</span>%</span>

				<eui-knapp
					vp-css-modifier-class="-transparent"
					vp-tooltip="Zooma till hel sida"
					:vp-inaktiverad="VerktygsfaltetSkaVaraInaktiverat"
					@tryckt="onZoomaTillHelSida()"
					style="width: 32px; height: 32px; padding: .4em; flex: none; border: 0; border-radius: 3px; margin-left: 0;"
				>
					<eui-modifierad-svg
						vp-ikon="zoomaTillHelSida"
					></eui-modifierad-svg>
				</eui-knapp>

			</template>

			<div
				ref="partialViewContainer"
				style="height: calc(95vh - 3rem); display: grid;"
			></div>

		</eui-dialog>
	`,

	components: {
		euiDialog,
		euiKnapp,
		euiModifieradSvg,
	},

	mixins: [ euiLifecycleStatusesMixin ],

	props: {
		vpDialogId: {
			type: String,
			default: null,
		},

		// Denna ska användas med .sync, dvs automagiskt lyssna på eventet 'update:vpVisaDialogen':
		vpVisaDialogen: {
			type: Boolean,
			default: false
		},

		vpDokumentDbId: {
			type: Number,
			default: 0
		},
		vpDokumentRekar: {
			type: Number,
			default: 0
		},
		vpDokumentFilnamn: {
			type: String,
			default: null
		},
		vpDokumentFilnamnUrlEscapead: {
			type: String,
			default: null
		},
		vpDokumentXxhash: {
			type: String,		// 'Number' funkar inte så bra här, för dessa c# ulong-värden "avrundas" till X siffror i js.
			default: null
		},
		vpDokumentOriginalfilUrlSegmentTill: {
			type: String,
			default: null
		},

		vpBreddMedEnhet: {
			type: String,
			default: '90rem'
		},

		vpVisaFoten: {
			type: Boolean,
			default: false
		},
		vpFotText: {
			type: String,		// Får innehålla viss inline html.
			default: '&nbsp;'
		},

		vpDialogStack: {
			type: Array,
			required: true,
		},
	},

	data() {
		return {
			uniktIdNr: ++uniktIdCounter,
			uniktId: 'eui-document-viewer-dialog-unikt-' + uniktIdCounter,

			// Obs! Endast för läsning, typ! Ändring sker alltid genom events till $root (där denna array finns):
			dialogStack: this.vpDialogStack,		// Arrays are reference types in JavaScript. *MEN* det funkar inte riktigt så i Vue!!

			dialogConfig: new euiDialogClasses.dialogConfig([
				new euiDialogClasses.knappAvbryt({ text: 'Stäng', cssModifierClass: '-primar' }),
			]),

			visaDialogen: false,

			documentViewerInstance: undefined,
			documentViewerFirstPageRendered: false,
			documentViewerZoomLevel: 100,
		};
	},

	computed: {
		dialogId() {
			return this.vpDialogId || ('document-viewer-' + this.uniktIdNr);
		},

		ZoommaUtSkaVaraInaktiverad()
		{
			return !this.documentViewerFirstPageRendered || this.documentViewerZoomLevel <= 10;
		},

		ZoommaInSkaVaraInaktiverad()
		{
			return !this.documentViewerFirstPageRendered || this.documentViewerZoomLevel >= 1000;
		},

		VerktygsfaltetSkaVaraInaktiverat()
		{
			return !this.documentViewerFirstPageRendered;
		},
	},

	watch: {
		vpVisaDialogen(nyttVarde, tidigareVarde) {
			// Obs! Denna watch triggas *inte* vid initial rendering med värdet true!

			//this.visaDialogen = nyttVarde;
			this.dialogConfig.visas = nyttVarde;
		},

		['dialogConfig.visas'] (nyttVarde, tidigareVarde) {

			if (nyttVarde)
			{
				// Dialogrutan går från dold => visas:
				let dialogkomponentensThis = this;

				this.$root.AjaxpostaOchHanteraResultat('/verifikat-documentviewer-partial', {
					formData: objectToFormData({
						dbId: this.vpDokumentDbId,
						rekar: this.vpDokumentRekar,
						filnamn: this.vpDokumentFilnamnUrlEscapead,
						xxHash: this.vpDokumentXxhash,
					}),
					//withoutSpinner: false,
					doljSpinnerOnSuccess: true,

					onFailureFunction: (resultat) => {

						// Först ska documentviewerdialogen stängas:
						this.dialogConfig.visas = false;

						// Visa failure-resultatet:
						this.$root.visaResultatmeddelande(resultat);
					},

					onCatchedErrorFunction: (error) => {

						// Först ska documentviewerdialogen stängas:
						this.dialogConfig.visas = false;

						// Visa felet:
						this.$root.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = false;
						this.$root.visaAxiosFelmeddelande(error);
					},

					onSuccessFunction: (resultat) => {

						if (resultat.CustomData !== null)
						{
							//console.log(resultat);
							var htmlString = resultat.CustomData;
							var target = dialogkomponentensThis.$refs.partialViewContainer;	//document.getElementById("target");
							target.insertAdjacentHTML('beforeend', htmlString);

							var scripts = target.getElementsByTagName('script');

							// I detta case finns det bara 1 <script> + vi injektar tillbaka det på samma plats, vilket skulle få den här whilen att gå i oändlighet, så:
							//while (scripts.length)
							//{
							var script = scripts[0];
							script.parentNode.removeChild(script);

							var newScript = document.createElement('script');

							// Kopiera attributen!
							newScript.type = script.type;
							newScript.id = script.id;

							if (script.src)
							{
								newScript.src = script.src;
							}
							else if (script.textContent)
							{
								newScript.textContent = script.textContent;
							}
							else if (script.innerText)
							{
								newScript.innerText = script.innerText;
							}

							//document.body.appendChild(newScript);
							target.appendChild(newScript);
							//}
						}
					},
				});
			}
			else
			{
				// Dialogrutan går från visas => dold:

				if (this.documentViewerInstance)
				{
					this.documentViewerInstance.dispose();
					this.documentViewerInstance = undefined;
				}

				this.documentViewerZoomLevel = 100;
				this.documentViewerFirstPageRendered = false;
			}

			// Propen används med .sync i parent component:
			this.$emit('update:vpVisaDialogen', nyttVarde);
		},
	},

	methods: {
		onLaddaNer() {

			var element = document.createElement('a');
			element.setAttribute('href', this.vpDokumentOriginalfilUrlSegmentTill);
			element.setAttribute('download', this.vpDokumentFilnamn);
			element.style.display = 'none';
			// Vissa webbläsare lär kräfva att elementet faktiskt läggs till DOM:
			document.body.appendChild(element);
			element.click();
			//document.body.removeChild(element);

			document.activeElement.blur();	// Inget fokuserat.
		},

		onSkrivUt() {
			if (this.documentViewerInstance)
			{
				this.documentViewerInstance
					.iframe.contentWindow.readerControl
					.doPrint('');
			}

			document.activeElement.blur();	// Inget fokuserat.
		},

		onZoomaUt() {
			if (this.documentViewerInstance)
			{
				if (this.documentViewerZoomLevel > 10)
				{
					this.documentViewerZoomLevel = this.documentViewerZoomLevel - 10;
					this.documentViewerInstance
						.setZoomLevel(this.documentViewerZoomLevel / 100);
				}
			}

			document.activeElement.blur();	// Inget fokuserat.
		},

		onZoomaIn() {
			if (this.documentViewerInstance)
			{
				if (this.documentViewerZoomLevel < 1000)
				{
					this.documentViewerZoomLevel = this.documentViewerZoomLevel + 10;
					this.documentViewerInstance
						.setZoomLevel(this.documentViewerZoomLevel / 100);
				}
			}

			document.activeElement.blur();	// Inget fokuserat.
		},

		onZoomaTillHelSida() {
			if (this.documentViewerInstance)
			{
				this.documentViewerInstance
					.fitPage();

				this.documentViewerZoomLevel = Math.round(this.documentViewerInstance.getZoomLevel() * 100);
			}

			document.activeElement.blur();	// Inget fokuserat.
		},

		onKnappTrycktIDialog({ eventId, eventData })
		{
			// Skicka bara ett eget event för samma sak uppåt:
			// Obs! $root nedan!
			this.$root.$emit('knapp-tryckt-i-documentviewerdialog',
				// Payload:
				{ eventId: eventId, eventData: eventData }
			);
		},

		onDialogenInaktiverad()
		{
			// Skicka bara ett eget event för samma sak uppåt:
			// Obs! $root nedan!
			this.$root.$emit('documentviewerdialog-inaktiverad');
		},

		onDialogenStangs(dialogId)
		{
			// Skicka bara ett eget event för samma sak uppåt:
			// Obs! $root nedan!
			this.$root.$emit('documentviewerdialog-stangs', dialogId);
		},
	},


	//== Lifecycle hooks  ================================================================================================================

	beforeCreate() {
		// Called synchronously immediately after the instance has been initialized, before data observation and event/watcher setup.
	},

	created()
	{
		// Called synchronously after the instance is created. At this stage, the instance has finished processing the options which means the following have been set up: data observation, computed properties, methods, watch/event callbacks. However, the mounting phase has not been started, and the $el property will not be available yet.
	},

	beforeUpdate() {
		//console.log('beforeUpdate');
	},

	updated() {
		//console.log('updated');
	},

	mounted() {
		// Note that mounted does not guarantee that all child components have also been mounted.
		//-----------------------------------------------------------------------------------------------------------------------
		// Mixin hooks will be called *before* the component’s/app’s own hooks. Ordning:
		//
		// 1. Mixins mounted hook.
		// 2. Appens/komponentens mounted hook.
		//
		// 3. Mixins mounted hook + nextTick (DOM not updated yet).
		// 4. Appens/komponentens mounted hook + nextTick (DOM not updated yet).
		//
		// 5. Mixins mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
		// 6. Appens/komponentens mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
		//
		// Det är *först efter steg 4* ovan som allt är färdigrenderat, med avseende på Vue-grejs som exempelvis all reaktivitet som förekommer i appen (ex visa/dölj element)!
		//
		// Alltså, saker som ska göras i denna mixins mounted och som ska ske *efter* steg 2 ovan:
		// a) kan göras som steg 3 ovan, *om* det *inte* är beroende av att allt reaktivt är garanterat färdigrenderat eller
		// b) måste göras som steg 5 ovan, *om* det är beroende av att allt reaktivt är garanterat färdigrenderat.
		//-----------------------------------------------------------------------------------------------------------------------

		//## 2. Appens/komponentens mounted hook:  #################################
		//console.log('2. Appens/komponentens mounted hook');

		this.$nextTick(function () {
			// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
			// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:

			//## 4. Appens/komponentens mounted hook + nextTick (DOM not updated yet):  #################################
			//console.log('4. Appens/komponentens mounted hook + nextTick');

			// FÖRST NU initieras visningen *om* den är satt via vpVisaDialogen att den ska visas initialt:
			//this.visaDialogen = this.vpVisaDialogen;
			this.dialogConfig.visas = this.vpVisaDialogen;

			window.ssoVerifikat.documentViewerDialogThis = this;

			// Resten av initieringen sker reaktivt genom watch!
		});
	},

	beforeDestroy()
	{
		// Called right before a Vue instance is destroyed. At this stage the instance is still fully functional.
		// This hook is not called during server-side rendering.
	},

	destroyed()
	{
		// Called after a Vue instance has been destroyed. When this hook is called, all directives of the Vue instance have been unbound, all event listeners have been removed, and all child Vue instances have also been destroyed.
		// This hook is not called during server-side rendering.
	},
};




//###################################################################################################

// Eventhandlers för DocumentUltimates events (mappade till funktionsnamnen nedan):

window.documentViewerLoaded = (sender, e) =>
{
	//logEvent(sender, e);

	window.ssoVerifikat.documentViewerDialogThis.documentViewerInstance = sender;
}

window.documentViewerDocumentLoaded = (sender, e) =>
{
	//logEvent(sender, e);

	sender.setToolMode('Pan');

	// För på mobiler så respekteras inte alltid det värde som satts så DocumentViewer skapades:
	// Denna behövs egentligen inte längre, för mobilläget är deaktiverat med propertyn MobileMode satt till MobileMode.Never.
	sender.setZoomLevel(1);
}

window.documentViewerPageRendered = (sender, e) =>
{
	//logEvent(sender, e);

	window.ssoVerifikat.documentViewerDialogThis.documentViewerFirstPageRendered = true;
}





window.documentViewerFailed = (sender, e) =>
{
	//logEvent(sender, e);
}

window.documentViewerPageChanged = (sender, e) =>
{
	//logEvent(sender, e);
}

window.documentViewerRotationChanged = (sender, e) =>
{
	//logEvent(sender, e);
}

window.documentViewerDownloading = (sender, e) =>
{
	//logEvent(sender, e);
}

window.documentViewerPrinting = (sender, e) =>
{
	//logEvent(sender, e);
}

window.documentViewerPrintProgress = (sender, e) =>
{
	//logEvent(sender, e);
}

window.documentViewerPrinted = (sender, e) =>
{
	//logEvent(sender, e);
}

window.documentViewerTextSelected = (sender, e) =>
{
	//logEvent(sender, e);
}

window.documentViewerTextCopied = (sender, e) =>
{
	//logEvent(sender, e);
}

//function logEvent(sender, e)
//{
//	console.log(sender);
//	console.log(e);
//}
